import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/layout/AppLayout.vue'),
    children: [
      { path: '', redirect: '/dashboard' },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/CrossDashboardView.vue'),
        meta: { title: '跨平台儀表板' },
      },
      {
        path: 'platforms',
        name: 'platforms',
        component: () => import('@/views/platforms/PlatformsListView.vue'),
        meta: { title: '子平台管理' },
      },
      {
        path: 'platforms/:id/features',
        name: 'platform-features',
        component: () => import('@/views/platforms/PlatformFeaturesView.vue'),
        meta: { title: '平台 Features 啟用' },
        props: true,
      },
      {
        path: 'platforms/:id/role-permissions',
        name: 'platform-role-permissions',
        component: () => import('@/views/platforms/PlatformRolePermissionsView.vue'),
        meta: { title: 'Role 權限矩陣' },
        props: true,
      },
      {
        path: 'features',
        name: 'features-catalog',
        component: () => import('@/views/features/FeaturesCatalogView.vue'),
        meta: { title: 'Feature 主清單' },
      },
      {
        path: 'operation-users',
        name: 'operation-users',
        component: () => import('@/views/users/OperationUsersView.vue'),
        meta: { title: '營運後台用戶' },
      },
      {
        path: 'agents',
        name: 'agents',
        component: () => import('@/views/agents/AgentsListView.vue'),
        meta: { title: '代理商列表' },
      },
      {
        path: 'audit-logs',
        name: 'audit-logs',
        component: () => import('@/views/audit/AuditLogListView.vue'),
        meta: { title: '審計記錄' },
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/profile/ProfileView.vue'),
        meta: { title: '個人資料' },
      },
      {
        path: 'admin/password-reset',
        name: 'admin-password-reset',
        component: () => import('@/views/admin/PasswordResetView.vue'),
        meta: { title: '重設使用者密碼' },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: { public: true, title: '忘記密碼' },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Auth guard：所有非 public 頁面需要登入
// 注意：fetchMe 內部有 in-flight 保護，多 caller（這裡 + App.vue onMounted）會共享同一個
// promise；所以這裡只要 user=null 就 await，不必檢查 loading（檢查 loading 反而會 race）。
router.beforeEach(async (to) => {
  if (to.meta.public) return true;

  const auth = useAuthStore();
  if (auth.user === null) {
    await auth.fetchMe();
  }
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  return true;
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = `${to.meta.title as string} · Noah 營運後台`;
  }
});
